export const enum DISPLAY_MODE {
  BROWSER_TAB = 'browser-tab',
  STANDALONE = 'standalone',
  STANDALONE_IOS = 'standalone-ios',
}

export const enum INSTALL_BUTTON_RESULTS {
  INSTALLING,
  IS_INSTALLED_ALREADY,
  CAN_NOT_INSTALL,
}
